import { ReactNode } from "react"
import { ConfigProvider } from "antd"

type Props = { children: ReactNode; color?: string }

export const SpinProvider = ({ children, color = "#1677ff" }: Props) => {
	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: color,
				},
			}}
		>
			{children}
		</ConfigProvider>
	)
}
